<template lang="pug">
//- TODO: This component might not need to be a separate
//- component, as of right now so many of the behavioral
//- and functional requirements live in the parent
//- component; we can move this component there.
//-
//- Bernat Jufré 2022-03-31
.form-group(:class="{ 'has-error': hasError }")
  .d-flex.justify-content-between
    label.control-label
      slot(name="label")
    slot(
      name="select-all"
      v-bind="{ onSelectAll }"
    )
  AppSelect.select-rule-user-ids(
    :value="value"
    :options="options"
    :select2-options="select2Options"
    @input="onSelect"
  )
  //- Allow passing custom error from the parent
  slot(name="error")
</template>

<script>
export default {
  name: 'NewJobSitesMembersTeamsSelect',
  props: {
    value: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    hasError: {
      type: Boolean,
      required: true,
    },
    teamsEnabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['input'],
  data() {
    return {
      select2Options: Object.freeze({
        width: '100%',
        multiple: true,
        allowClear: true,
        // #teams-addon
        placeholder: this.teamsEnabled ? 'Select teams & members' : 'Select members',
      }),
    };
  },
  methods: {
    onSelectAll(allIds) {
      this.$emit('input', allIds);
    },
    onSelect(selectedIds) {
      return this.$emit('input', selectedIds);
    },
  },
};
</script>
